import { useContext } from "react";
import { NavContext } from "../Nav/NavContext";

export function useShoppingList() {
  const [{ shoppingListNumItems }] = useContext(NavContext);

  return { numOfItems: shoppingListNumItems };
}
